import { memo } from 'react';

import { StatusBadge } from './DashboardUI';
import { formatAmount, formatCellValue } from '../utils/formatters';

export const TABLE_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
};

const getAlignClass = (align) => `td-align-${align || TABLE_ALIGN.LEFT}`;

const renderCellContent = (column, row) => {
  if (column.render) {
    return column.render(row);
  }

  const value = row[column.key];

  switch (column.type) {
    case 'amount':
      return formatAmount(value);
    case 'status':
      return (
        <StatusBadge
          status={row[column.statusKey || 'status']}
          label={row[column.labelKey || 'statusLabel']}
        />
      );
    default:
      return formatCellValue(value);
  }
};

const getCellStyle = (column, row) => {
  const style = {};

  if (column.color) {
    style.color = column.color;
  }
  if (column.bold) {
    style.fontWeight = 600;
  }
  if (column.getStyle) {
    Object.assign(style, column.getStyle(row) || {});
  }

  return Object.keys(style).length ? style : undefined;
};

export const DashboardTable = memo(function DashboardTable({
  columns,
  rows,
  scrollable = false,
  getRowKey,
}) {
  const wrapClass = scrollable ? 'tbl-wrap tbl-wrap-scroll' : 'tbl-wrap';

  return (
    <div className={wrapClass}>
      <table>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={getAlignClass(column.align)}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={getRowKey ? getRowKey(row, rowIndex) : rowIndex}>
              {columns.map((column) => {
                const cellClass = [
                  column.mono ? 'td-mono' : '',
                  getAlignClass(column.align),
                ]
                  .filter(Boolean)
                  .join(' ');

                return (
                  <td
                    key={column.key}
                    className={cellClass || undefined}
                    style={getCellStyle(column, row)}
                  >
                    {renderCellContent(column, row)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});
